class QuantityInput extends HTMLElement {
  onClick = (e) => {
    const button = e.target.closest(".quantity__button");
    if (!button) return;

    this.onButtonClick(e, button);
  };

  onChange = (e) => {
    if (e.target === this.input) this.validateQtyRules();
  };

  connectedCallback() {
    this.addEventListener("click", this.onClick);
    this.addEventListener("change", this.onChange);
    this.validateQtyRules();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    this.removeEventListener("change", this.onChange);
  }

  get input() {
    return this.querySelector("input");
  }

  onButtonClick(event, button) {
    event.preventDefault();
    const input = this.input;
    if (!input) return;

    const previousValue = input.value;
    button.name === "plus" ? input.stepUp() : input.stepDown();
    if (previousValue !== input.value)
      input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  validateQtyRules() {
    const input = this.input;
    if (!input) return;

    const value = parseInt(input.value);
    const min = input.min === "" ? null : parseInt(input.min);
    const buttonMinus = this.querySelector("[name='minus']");

    if (min !== null) {
      buttonMinus?.classList.toggle("disabled", value <= min);
    }
    if (input.max) {
      const max = parseInt(input.max);
      const buttonPlus = this.querySelector("[name='plus']");
      buttonPlus?.classList.toggle("disabled", value >= max);
    }

    // At quantity 1 the decrease button becomes a remove action, so it swaps
    // to the bin icon — but only where stepping down to 0 is actually allowed,
    // otherwise it would render a bin that can't do anything.
    buttonMinus?.classList.toggle(
      "quantity__button--remove",
      value <= 1 && (min === null || min < 1),
    );
  }
}
if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}
